import axios from 'axios';
import { Base_URL } from '../url';


// centralised API functions for the Production Plan screen
export const getProductionPlans = async () => {
const res = await axios.get(`${Base_URL}/ProductionOrder/getPlans`);
return res.data;
};


export const getProductionTypes = async () => {
const res = await axios.get(`${Base_URL}/ProductionOrder/getProductionType`);
return res.data;
};


export const getStatusIds = async () => {
const res = await axios.get(`${Base_URL}/ProductionOrder/getStatusId`);
return res.data;
};


export const getCurrencies = async () => {
const res = await axios.get(`${Base_URL}/CurrencyMaster/GetAllCurrencies`);
return res.data;
};


// Example submit function — adapt endpoint name to your backend contract
export const submitProductionPlan = async (payload) => {
// change endpoint path if your backend uses a different route
const res = await axios.post(`${Base_URL}/ProductionOrder/createOrder`, payload);
return res.data;
};